"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.icons = exports.createTheme = void 0;
var nebula_1 = require("@ovotech/nebula");
var deepmerge_1 = __importDefault(require("deepmerge"));
var icons_1 = require("../icons");
var config = {
    colors: {
        fuelElec: '#E7A234',
        fuelGas: '#26ADE4',
        fuelSolar: '#E99921',
        fuelComparison: '#197278',
        invert: 'linear-gradient(150.78deg, #091E24 39.33%, #2F3749 85.57%)',
        invertContrast: '#FFF',
    },
    graphicColors: [
        '#005365',
        '#3EBFDB',
        '#03D6BD',
        '#D7C3FD',
        '#A07CDF',
        '#230F7F',
    ],
    radii: {
        large: '0.8rem',
    },
};
var icons = {
    bell: icons_1.BellIcon,
    star: icons_1.StarIcon,
    elecBoltInTriangle: icons_1.BlackWarningIcon,
    warningTriangle: icons_1.RedWarningSignIcon,
    peakLegacy: icons_1.PeakLegacy,
    edit: icons_1.Edit,
    offpeakLegacy: icons_1.OffpeakLegacy,
    date: icons_1.Date,
    view: icons_1.View,
    payment: icons_1.Payment,
    checkInCircle: icons_1.Check,
    checkInCircleFilled: icons_1.CheckFilled,
    usage: icons_1.Usage,
    accountSummary: icons_1.AccountSummary,
    payments: icons_1.Payments,
    meterReads: icons_1.MeterReads,
    billing: icons_1.Billing,
    calendar: icons_1.Calendar,
    dots: icons_1.Dots,
    percent: icons_1.Percent,
    warning: icons_1.WarningSign,
    info: icons_1.Info,
    'thumbs-up': icons_1.ThumbsUp,
    'thumbs-down': icons_1.ThumbsDown,
    'no-bill': icons_1.NoBillIcon,
    secure: icons_1.Secure,
    equals: icons_1.Equals,
    coin: icons_1.Coin,
    'copper-coin': icons_1.CopperCoin,
    wallet: icons_1.Wallet,
    'supply-point': icons_1.SupplyPoint,
    meter: icons_1.Meter,
    'standing-charge': icons_1.StandingCharge,
    'evening-and-weekend': icons_1.EveningAndWeekend,
    anytime: icons_1.Anytime,
    heating: icons_1.Heating,
    peak: icons_1.Peak,
    offpeak: icons_1.Offpeak,
    'super-offpeak': icons_1.SuperOffpeak,
    'ev-charge': icons_1.EVCharge,
    'green-vehicle': icons_1.GreenVehicle,
    battery: icons_1.Battery,
    coins: icons_1.Coins,
    solar: icons_1.Solar,
    interval: icons_1.Interval,
    exclamation: icons_1.Exclamation,
    shoulder: icons_1.Shoulder,
    vehicle: icons_1.Vehicle,
    profile: icons_1.Profile,
    wifi: icons_1.Wifi,
    card: icons_1.Card,
};
exports.icons = icons;
function createTheme(customTheme, additional) {
    var mergeOptions = {
        arrayMerge: function (_, src) { return src; },
    };
    var modifications = (0, deepmerge_1.default)(customTheme !== null && customTheme !== void 0 ? customTheme : {}, additional !== null && additional !== void 0 ? additional : {}, mergeOptions);
    var theme = (0, nebula_1.createTheme)(config, modifications);
    return theme;
}
exports.createTheme = createTheme;
